import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=5f07db1a&scoped=true&lang=pug"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=5f07db1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07db1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f07db1a')) {
      api.createRecord('5f07db1a', component.options)
    } else {
      api.reload('5f07db1a', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=5f07db1a&scoped=true&lang=pug", function () {
      api.rerender('5f07db1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductForm.vue"
export default component.exports